import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import classNames from "classnames";
import FeatherIcon from "feather-icons-react";
import { useDispatch, useSelector } from "react-redux";

import { IReduxState } from "../../utils/types";
import { LogoutAction } from "../../Redux/Actions/AuthAction";

const ProfileMenus = [
  {
    label: "Logout",
    icon: "log-out",
    redirectTo: "/auth/logout",
  },
];

const ProfileDropdown = () => {
  const dispatch = useDispatch();

  const reduxState = useSelector((state: IReduxState) => state.Auth);
  //const profilePic = reduxState?.user?.picture || null;
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

  /*
   * toggle profile-dropdown
   */
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = async () => {
    await dispatch(LogoutAction());
  };

  
  return (
    <Dropdown show={dropdownOpen} onToggle={toggleDropdown}>
      <Dropdown.Toggle
        id="dropdown-profile"
        as="a"
        onClick={toggleDropdown}
        className={classNames(
          "nav-link",
          "nav-user",
          "me-0",
          "cursor-pointer",
          { show: dropdownOpen }
        )}
      >
        {/* <img src={profilePic!} className="rounded-circle" alt="" /> */}

        <span className="profileuserimg rounded-circle">
          {reduxState?.user?.given_name &&
            reduxState?.user?.family_name &&
            reduxState?.user?.given_name?.charAt(0).toUpperCase() +
              reduxState?.user?.family_name?.charAt(0).toUpperCase()}
        </span>

        <span className="pro-user-name ms-2">
          {reduxState?.user?.name
            .split(/ /g)
            .map(
              (x: any) =>
                `${x.substring(0, 1).toUpperCase()}${x.substring(1)}`
            )
            .join(" ")}{" "}
          <i className="uil uil-angle-down"></i>
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-end profile-dropdown">
        <div onClick={toggleDropdown}>
          {(ProfileMenus || []).map((item, i) => {
            return (
              <React.Fragment key={i}>
                <div
                  className="dropdown-item notify-item"
                  key={i + "-profile-menu"}
                  onClick={handleLogout}
                >
                  <FeatherIcon
                    icon={item.icon}
                    className="icon-dual icon-xs me-1"
                  />
                  <span>{item.label}</span>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
